export default __webpack_public_path__ + "static/muli-v20-latin-regular-38b72a2027777b0ec58ac5625bdb8cbc.woff";